// src/App.js - Complete working version with bottom stats
import React, { useState } from 'react';
import './App.css';

// Complete transform HTML function with all original logic + new features
function transformHtml(htmlContent, bannerType = "none", footerType = "None", options = {}) {
  // Destructure new options
  const {
    hideFirstH2 = false,
    addImageClasses = false,
    addBlockquoteClass = false,
    addNoteBoxes = false,
    splitEmbeddedQuotes = false,
    convertTablesToColumns = false,
    formatSourceText = false,
    removeInlineStyles = false
  } = options;

  // Create a temporary div to parse the HTML
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlContent;
  
  // Get or create document structure
  let htmlDoc = tempDiv.querySelector('html');
  if (!htmlDoc) {
    htmlDoc = document.createElement('html');
    htmlDoc.innerHTML = htmlContent;
    tempDiv.appendChild(htmlDoc);
  }
  
  let head = htmlDoc.querySelector('head');
  let body = htmlDoc.querySelector('body');
  
  if (!head) {
    head = document.createElement('head');
    htmlDoc.insertBefore(head, body);
  }
  
  if (!body) {
    body = document.createElement('body');
    body.innerHTML = htmlContent;
    htmlDoc.appendChild(body);
  }

  // Remove all existing <link> and <script> elements
  htmlDoc.querySelectorAll("link, script").forEach(el => el.remove());

  // --- NEW FEATURE 2 & 3: Add Classes to Images ---
  if (addImageClasses) {
    body.querySelectorAll('img').forEach(img => {
      // Add img-20 class
      const existingClasses = img.getAttribute('class') || '';
      const classArray = existingClasses.split(' ').filter(c => c.trim() !== '');
      
      if (!classArray.includes('img-20-big')) {
        classArray.push('img-20-big');
      }
      
      // Add center class if no align="right"
      const alignAttribute = img.getAttribute('align');
      if (alignAttribute !== 'right' && !classArray.includes('center')) {
        classArray.push('center');
      }
      
      img.setAttribute('class', classArray.join(' '));
    });
  }

  // --- NEW FEATURE 4: Convert <p><em> pattern to <blockquote> ---
  if (addBlockquoteClass) {
    body.querySelectorAll('p > em:first-child').forEach(em => {
      const paragraph = em.parentNode;
      // Check if the em is the first child or one of the first children
      const firstChild = paragraph.firstChild;
      if (firstChild === em || (firstChild.nodeType === Node.TEXT_NODE && firstChild.textContent.trim() === '' && firstChild.nextSibling === em)) {
        // Create new blockquote element
        const blockquote = document.createElement('blockquote');
        blockquote.innerHTML = paragraph.innerHTML;
        
        // Copy any existing attributes from p to blockquote (except tag-specific ones)
        Array.from(paragraph.attributes).forEach(attr => {
          if (attr.name !== 'class' || attr.value.trim() !== '') {
            blockquote.setAttribute(attr.name, attr.value);
          }
        });
        
        // Replace the p element with blockquote
        paragraph.parentNode.replaceChild(blockquote, paragraph);
      }
    });
  }

  // --- NEW FEATURE 5: Split embedded quotes from paragraphs ---
  if (splitEmbeddedQuotes) {
    // Create a copy of the paragraphs array since we'll be modifying the DOM
    const paragraphs = Array.from(body.querySelectorAll('p'));
    
    paragraphs.forEach(p => {
      // Check if paragraph contains the pattern: <br><br><em>...</em><br><br>
      const innerHTML = p.innerHTML;
      
      // Look for pattern with <em> surrounded by <br> tags
      const quotePattern = /<br\s*\/?>\s*<br\s*\/?>\s*<em[^>]*>(.*?)<\/em>\s*<br\s*\/?>\s*<br\s*\/?>/i;
      const match = innerHTML.match(quotePattern);
      
      if (match) {
        const fullMatch = match[0];
        const quoteContent = match[1];
        const beforeQuote = innerHTML.substring(0, innerHTML.indexOf(fullMatch)).trim();
        const afterQuote = innerHTML.substring(innerHTML.indexOf(fullMatch) + fullMatch.length).trim();
        
        // Only proceed if there's content before AND after the quote
        if (beforeQuote && afterQuote) {
          // Create the three new elements
          const beforeP = document.createElement('p');
          const blockquote = document.createElement('blockquote');
          const afterP = document.createElement('p');
          
          // Set content (remove trailing/leading <br> tags)
          beforeP.innerHTML = beforeQuote.replace(/(<br\s*\/?>)*$/i, '');
          blockquote.innerHTML = quoteContent;
          afterP.innerHTML = afterQuote.replace(/^(<br\s*\/?>)*/i, '');
          
          // Insert the new elements before the original paragraph
          p.parentNode.insertBefore(beforeP, p);
          p.parentNode.insertBefore(blockquote, p);
          p.parentNode.insertBefore(afterP, p);
          
          // Remove the original paragraph
          p.remove();
        }
      }
    });
  }

  // --- NEW FEATURE 6: Wrap NOTE: paragraphs in note-box div ---
  if (addNoteBoxes) {
    body.querySelectorAll('p').forEach(p => {
      if (p.textContent.includes('NOTE:')) {
        const noteDiv = document.createElement('div');
        noteDiv.className = 'note-box';
        p.parentNode.insertBefore(noteDiv, p);
        noteDiv.appendChild(p);
      }
    });
  }

  // --- NEW FEATURE 8: Format Source Text ---
  if (formatSourceText) {
    // Find paragraphs that contain "Source:" text
    body.querySelectorAll('p').forEach(p => {
      const textContent = p.textContent;
      if (textContent.toLowerCase().includes('source:')) {
        // Extract the source text after "Source:"
        const sourceMatch = textContent.match(/source:\s*(.+)/i);
        if (sourceMatch) {
          const sourceText = sourceMatch[1].trim();
          
          // Create the new structure
          const sourceDiv = document.createElement('div');
          
          // Create the title paragraph
          const sourceTitleP = document.createElement('p');
          sourceTitleP.className = 'sourcetitle';
          sourceTitleP.textContent = 'Source';
          
          // Create the source content paragraph
          const sourceContentP = document.createElement('p');
          sourceContentP.className = 'source';
          sourceContentP.textContent = sourceText;
          
          // Add both paragraphs to the div
          sourceDiv.appendChild(sourceTitleP);
          sourceDiv.appendChild(sourceContentP);
          
          // Replace the original paragraph
          p.parentNode.replaceChild(sourceDiv, p);
        }
      }
    });
  }

  // --- NEW FEATURE 7: Convert Tables to Column Divs ---
  if (convertTablesToColumns) {
    // Find tables that match the specific pattern for column conversion
    const tables = Array.from(body.querySelectorAll('table')).filter(table => {
      // Skip tables that contain PDF icons (handled by existing logic)
      const pdfImg = table.querySelector("img[src*='pdf-icon']");
      if (pdfImg) return false;
      
      // Check for the specific pattern: table with 2 cells, each containing an image
      const tbody = table.querySelector('tbody');
      const tr = tbody ? tbody.querySelector('tr') : table.querySelector('tr');
      
      if (tr) {
        const tds = Array.from(tr.querySelectorAll('td'));
        
        // Only convert if there are exactly 2 cells and both contain images
        if (tds.length === 2) {
          const cell1HasImage = tds[0].querySelector('img') !== null;
          const cell2HasImage = tds[1].querySelector('img') !== null;
          return cell1HasImage && cell2HasImage;
        }
      }
      
      return false;
    });
    
    tables.forEach(table => {
      const tbody = table.querySelector('tbody');
      const tr = tbody ? tbody.querySelector('tr') : table.querySelector('tr');
      const tds = Array.from(tr.querySelectorAll('td'));
      
      // Create the container div with "cont-r" class
      const containerDiv = document.createElement('div');
      containerDiv.className = 'cont-r';
      
      // Convert each td to a div
      tds.forEach((td, index) => {
        const columnDiv = document.createElement('div');
        
        // Add comment for column identification
        const columnName = index === 0 ? 'Left Column' : 'Right Column';
        const columnComment = document.createComment(` ${columnName} `);
        columnDiv.appendChild(columnComment);
        
        // Move all content from td to the new div
        while (td.firstChild) {
          columnDiv.appendChild(td.firstChild);
        }
        
        containerDiv.appendChild(columnDiv);
      });
      
      // Replace the table with the new div structure
      table.parentNode.replaceChild(containerDiv, table);
    });
  }

  // --- TABLE TRANSFORMATION START (PDF Icons) ---
  // Process <table> elements containing PDF icons: replace table with a <p> containing only the link
  Array.from(body.querySelectorAll("table")).forEach(table => {
    const pdfImg = table.querySelector("img[src*='pdf-icon']");
    if (pdfImg) {
      const link = table.querySelector("a[href]");
      if (link) {
        const newP = document.createElement("p");
        newP.innerHTML = link.outerHTML;
        table.parentNode.replaceChild(newP, table);
      }
    }
  });
  // --- TABLE TRANSFORMATION END ---

  // Transform <em><strong> to <strong><em> while retaining the text inside <strong>
  body.querySelectorAll("em > strong").forEach(strong => {
    const strongContent = strong.innerHTML;
    const newStrong = document.createElement("strong");
    const newEm = document.createElement("em");
    newEm.innerHTML = strongContent;
    newStrong.appendChild(newEm);
    strong.parentNode.replaceWith(newStrong);
  });

  // Heading tag transformations
  const transformations = [
    { from: "h4", to: "h5" },
    { from: "h3", to: "h4" },
    { from: "h2", to: "h3" },
    { from: "h1", to: "h2" }
  ];
  transformations.forEach(({ from, to }) => {
    body.querySelectorAll(from).forEach(element => {
      const replacement = document.createElement(to);
      replacement.innerHTML = element.innerHTML;
      Array.from(element.attributes).forEach(attr => {
        replacement.setAttribute(attr.name, attr.value);
      });
      element.parentNode.replaceChild(replacement, element);
    });
  });

  // --- NEW FEATURE 1: Hide First H2 and following HR (MOVED TO CORRECT POSITION) ---
  if (hideFirstH2) {
    const firstH2 = body.querySelector('h2');
    if (firstH2) {
      const comment = document.createComment(` Hidden H2: ${firstH2.outerHTML} `);
      firstH2.parentNode.replaceChild(comment, firstH2);
      
      // Check if the next sibling is an HR tag and hide it too
      let nextSibling = comment.nextSibling;
      while (nextSibling && nextSibling.nodeType === Node.TEXT_NODE && nextSibling.textContent.trim() === '') {
        nextSibling = nextSibling.nextSibling;
      }
      if (nextSibling && nextSibling.tagName === 'HR') {
        const hrComment = document.createComment(` Hidden HR following H2: ${nextSibling.outerHTML} `);
        nextSibling.parentNode.replaceChild(hrComment, nextSibling);
      }
    }
  }

  // Remove <strong> tags inside <h2>
  body.querySelectorAll("h2 strong").forEach(strong => {
    const textNode = document.createTextNode(strong.textContent);
    strong.parentNode.replaceChild(textNode, strong);
  });

  // Remove <hr> tags that immediately follow <h2> and remove all <hr> tags
  body.querySelectorAll("h2 + hr").forEach(hr => hr.remove());
  body.querySelectorAll("hr").forEach(hr => hr.remove());

  // Wrap each <h2> in a new section and move subsequent siblings into that section
  body.querySelectorAll('h2').forEach(h2 => {
    const section = document.createElement('section');
    const clonedH2 = h2.cloneNode(true);
    section.appendChild(clonedH2);
    const comment = document.createComment(` Section start for: ${clonedH2.textContent} `);
    h2.parentNode.insertBefore(comment, h2);
    h2.parentNode.insertBefore(section, h2);
    h2.remove();
    let sibling = section.nextSibling;
    while (sibling && sibling.tagName !== 'H2') {
      const next = sibling.nextSibling;
      section.appendChild(sibling);
      sibling = next;
    }
  });

  // Remove <p> elements that are empty or contain placeholders
  body.querySelectorAll('p').forEach(p => {
    if (p.innerHTML.trim() === '&nbsp;' || p.innerHTML.includes('__________')) {
      p.remove();
    }
  });

  // --- REPLACE VIDEO INTRODUCTION BLOCK ---
  // Look for the <p> that includes "maneuver through the course materials" and assume the block
  // consists of that <p>, the following <p>, and the next <p> containing the <iframe>.
  const videoIntroP = Array.from(body.querySelectorAll("p")).find(p =>
    p.textContent.includes("maneuver through the course materials")
  );
  if (videoIntroP) {
    const nodesToRemove = [];
    let current = videoIntroP;
    // Assume the block consists of 3 consecutive elements.
    for (let i = 0; i < 3 && current; i++) {
      nodesToRemove.push(current);
      current = current.nextElementSibling;
    }
    const newVideoDiv = document.createElement("div");
    newVideoDiv.className = "iframe-holder";
    newVideoDiv.id = "iframe-d2l-navigating-video";
    nodesToRemove[0].parentNode.insertBefore(newVideoDiv, nodesToRemove[0]);
    nodesToRemove.forEach(node => node.remove());
  }

  // --- REMOVE EXISTING BANNER BLOCK ---
  // If a banner block with class "dishid" exists, remove its entire container.
  const dishidBlock = body.querySelector("div.dishid");
  if (dishidBlock) {
    const parentContainer = dishidBlock.parentNode;
    if (parentContainer) {
      parentContainer.remove();
    } else {
      dishidBlock.remove();
    }
  }

  // --- REMOVE EXISTING FOOTER SNIPPETS ---
  // Remove any <div> elements that contain a <p> with class "endFlourish" and an image with "unbLogo.png"
  body.querySelectorAll("body > div").forEach(div => {
    if (div.innerHTML.includes('class="endFlourish"') && div.innerHTML.includes("unbLogo.png")) {
      div.remove();
    }
  });

  // Re-add essential CSS and script tags
  // Remove any comment nodes in the head before the <title> element
  const titleElement = head.querySelector("title");
  if (titleElement) {
    let node = head.firstChild;
    while (node && node !== titleElement) {
      const nextNode = node.nextSibling;
      if (node.nodeType === Node.COMMENT_NODE) {
        node.remove();
      }
      node = nextNode;
    }
  }
  
  head.innerHTML += `
  <!--CSS STYLE SHEETS -->
  <link href="/shared/online/styles/standardized/prime-theme.css" rel="stylesheet" type="text/css">
  <noscript>
    <link href="/shared/online/styles/standardized/prime-theme-no-script.css" rel="stylesheet" type="text/css">
  </noscript>
  <link href="/shared/online/styles/standardized/anim-on-scroll.css" rel="stylesheet" type="text/css">
  `;
  
  body.innerHTML += `
  <!--SCRIPTS -->
  <script src="/shared/online/scripts/js/animate-scroll.js"></script>
  <script src="/shared/online/scripts/js/prime-theme.js"></script>
  <script src="https://player.vimeo.com/api/player.js"></script>
  `;

  // Remove specific style attributes and data-preserver-spaces attributes
  body.querySelectorAll('[style]').forEach(element => {
    const styleValue = element.getAttribute('style');
    if (styleValue && (styleValue.includes('list-style-type: disc;') || styleValue.includes('list-style-type: decimal;'))) {
      element.removeAttribute('style');
    }
  });
  body.querySelectorAll('[data-preserver-spaces="true"]').forEach(element => {
    element.removeAttribute('data-preserver-spaces');
  });

  // --- NEW FEATURE: Remove ALL Inline Styles ---
  if (removeInlineStyles) {
    body.querySelectorAll('[style]').forEach(element => {
      element.removeAttribute('style');
    });
  }

  // Additional conversion functions
  function removeEmbedContainerClass() {
    const embedContainers = body.querySelectorAll('.embed-container');
    embedContainers.forEach(element => {
      element.classList.remove('embed-container');
      if (element.classList.length === 0) {
        element.removeAttribute('class');
      }
    });
  }

  function convertAccordionToDiv() {
    const buttons = body.querySelectorAll('.expand.dropbtn');
    buttons.forEach(button => {
      const titleText = button.textContent.trim();
      const contentId = button.id.replace('btn', 'acc_btn');
      const contentDiv = body.querySelector(`#${contentId}`);
      if (contentDiv) {
        const accordionDiv = document.createElement('div');
        accordionDiv.classList.add('base-accordion', 'accordion-primary');
        const titleButton = document.createElement('button');
        titleButton.classList.add('base-accordion-title-button');
        titleButton.title = "Press 'a' to open & close all accordions";
        titleButton.innerHTML = `<span>${titleText}</span>`;
        const newContentDiv = document.createElement('div');
        newContentDiv.innerHTML = contentDiv.innerHTML;
        accordionDiv.appendChild(titleButton);
        accordionDiv.appendChild(newContentDiv);
        contentDiv.parentElement.replaceChild(accordionDiv, contentDiv);
        button.remove();
      }
    });
  }

  function convertTabs() {
    const oldTabs = body.querySelector("#tabs");
    if (oldTabs) {
      const tabGroup = document.createElement("div");
      tabGroup.className = "tab-group";
      const tabDiv = document.createElement("div");
      tabDiv.className = "tab";
      const anchors = oldTabs.querySelectorAll("ul li a");
      anchors.forEach(anchor => {
        const buttonText = anchor.textContent.trim();
        const button = document.createElement("button");
        button.className = "tablinks";
        button.textContent = buttonText;
        tabDiv.appendChild(button);
      });
      tabGroup.appendChild(tabDiv);
      anchors.forEach(anchor => {
        const href = anchor.getAttribute("href");
        const oldContentDiv = body.querySelector(href);
        if (oldContentDiv) {
          const newContentDiv = document.createElement("div");
          newContentDiv.className = "tabcontent";
          newContentDiv.innerHTML = oldContentDiv.innerHTML;
          tabGroup.appendChild(newContentDiv);
          oldContentDiv.remove();
        }
      });
      oldTabs.parentNode.replaceChild(tabGroup, oldTabs);
    }
  }

  removeEmbedContainerClass();
  convertAccordionToDiv();
  convertTabs();

  // --- INSERT BANNER AND FOOTER SNIPPETS ---
  const bannerSnippets = {
    none: '',
    banner: `
      <!-- Banner -->
      <div>
                <img src="../images/headerImage.jpg" alt="Landscape" title="Banner" style="width:100%;" data-d2l-editor-default-img-style="true">
      </div>`,
    bannerTimeline: `
      <!-- Banner -->
      <div>
                <img src="../images/headerImage.jpg" alt="Landscape" title="Banner" style="width:100%;" data-d2l-editor-default-img-style="true">
      </div>
      <div class="timeline-container-alt" id="timelineContainerAlt"><!-- Steps dynamically generated --></div>
      <!-- Section start for: Introduction -->`,
    bannerPagination: `
      <!-- Banner -->
      <div>
                <img src="../images/headerImage.jpg" alt="Landscape" title="Banner" style="width:100%;" data-d2l-editor-default-img-style="true">
      </div>
      <div id="moduleProgressNew" class="module-progress-new"></div>
      <div id="timelineContainerNew" class="timeline-container-new"></div>`,
    progressive: `
      <!-- Progressive Banner -->
      <div class="timeline-banner">
        <div id="tl-grid" class="image-overlay-tl"></div>
                <img src="../images/headerImage.jpg" alt="Landscape" title="Banner" style="width:100%;" data-d2l-editor-default-img-style="true">
      </div>
      <br><p id="result"></p>`,
    timeline: `
      <div class="timeline-container-alt" id="timelineContainerAlt"><!-- Steps dynamically generated --></div>
      <!-- Section start for: Introduction -->`,
    pagination: `
      <!-- Pagination -->
      <div id="moduleProgressNew" class="module-progress-new"></div>
      <div id="timelineContainerNew" class="timeline-container-new"></div>`
  };

  const footerSnippets = {
    None: '',
    ClassicDiamond: `<p class="endFlourish"><span class="logo"><img class="displayed" src="/shared/cel/images/unbLogo.png" alt="UNB logo" width="15" height="14"></span></p>`,
    Image: `<div class="endFlourishImage"></div>`
  };

  // Insert banner snippet at the beginning of <body> if a banner option is selected
  if (bannerType !== "none" && bannerSnippets[bannerType]) {
    body.insertAdjacentHTML('afterbegin', bannerSnippets[bannerType]);
  }
  
  // Insert footer snippet at the end of <body> if a footer option is selected
  if (footerType !== "None" && footerSnippets[footerType]) {
    body.insertAdjacentHTML('beforeend', footerSnippets[footerType]);
  }

  return htmlDoc.outerHTML;
}

// Helper functions for database integration
const calculateTimeSaved = (htmlFilesProcessed) => {
  const minutesSaved = htmlFilesProcessed * 15;
  const hours = Math.floor(minutesSaved / 60);
  const minutes = minutesSaved % 60;
  
  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  } else {
    return `${minutes}m`;
  }
};

const logConversionToDatabase = async (conversionData) => {
  try {
    const response = await fetch('https://unbonlineprojects.ca/idd-apps/idd-css-swap/api.php?action=log_conversion', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(conversionData)
    });

    if (response.ok) {
      const result = await response.json();
      console.log('Conversion logged successfully:', result);
    } else {
      console.error('Failed to log conversion');
    }
  } catch (error) {
    console.error('Error logging conversion:', error);
  }
};

const getConversionStats = async () => {
  try {
    const response = await fetch('https://unbonlineprojects.ca/idd-apps/idd-css-swap/api.php?action=stats');
    if (response.ok) {
      const stats = await response.json();
      return stats;
    }
  } catch (error) {
    console.error('Error getting stats:', error);
  }
  return null;
};

function App() {
  const [sourceDir, setSourceDir] = useState(null);
  const [targetDir, setTargetDir] = useState(null);
  const [banner, setBanner] = useState('none');
  const [footer, setFooter] = useState('None');
  const [prefix, setPrefix] = useState('None');
  
  // New state variables for the additional features
  const [hideFirstH2, setHideFirstH2] = useState(false);
  const [addImageClasses, setAddImageClasses] = useState(false);
  const [addBlockquoteClass, setAddBlockquoteClass] = useState(false);
  const [addNoteBoxes, setAddNoteBoxes] = useState(false);
  const [splitEmbeddedQuotes, setSplitEmbeddedQuotes] = useState(false);
  const [convertTablesToColumns, setConvertTablesToColumns] = useState(false);
  const [formatSourceText, setFormatSourceText] = useState(false);
  const [removeInlineStyles, setRemoveInlineStyles] = useState(false);
  
  const [processing, setProcessing] = useState(false);
  const [result, setResult] = useState('');
  const [stats, setStats] = useState(null);

  // Check if File System Access API is supported
  const isFileSystemSupported = 'showDirectoryPicker' in window;

  // Load stats when component mounts
  React.useEffect(() => {
    const loadStats = async () => {
      try {
        const statsData = await getConversionStats();
        setStats(statsData);
      } catch (error) {
        console.log('Stats unavailable');
      }
    };
    loadStats();
  }, []);

  const formatTimeSaved = (minutes) => {
    if (!minutes) return '0m';
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const days = Math.floor(hours / 24);
    const remainingHours = hours % 24;
    
    if (days > 0) return `${days}d ${remainingHours}h ${mins}m`;
    if (hours > 0) return `${hours}h ${mins}m`;
    return `${mins}m`;
  };

  const selectSourceDirectory = async () => {
    if (!isFileSystemSupported) {
      alert('File System Access API is not supported. Please use Chrome 86+');
      return;
    }

    try {
      const dirHandle = await window.showDirectoryPicker({
        mode: 'read'
      });
      setSourceDir(dirHandle);
    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error('Error selecting source directory:', err);
      }
    }
  };

  const selectTargetDirectory = async () => {
    if (!isFileSystemSupported) {
      alert('File System Access API is not supported. Please use Chrome 86+');
      return;
    }

    try {
      const dirHandle = await window.showDirectoryPicker({
        mode: 'readwrite'
      });
      setTargetDir(dirHandle);
    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error('Error selecting target directory:', err);
      }
    }
  };

  // COMPLETE processDirectory function with database integration
  const processDirectory = async () => {
    if (!sourceDir || !targetDir) {
      alert('Please select both source and target directories');
      return;
    }

    const startTime = Date.now();
    setProcessing(true);
    setResult('');
    let processedCount = 0;
    let copiedCount = 0;

    try {
      // Check if target directory has files (optional warning)
      let hasFiles = false;
      for await (const [, handle] of targetDir.entries()) {
        if (handle.kind === 'file') {
          hasFiles = true;
          break;
        }
      }

      if (hasFiles) {
        const confirmed = window.confirm(
          'The target directory may contain important files. Overwriting may occur. Do you want to continue?'
        );
        if (!confirmed) {
          setProcessing(false);
          return;
        }
      }

      // Prepare options object for new features
      const transformOptions = {
        hideFirstH2,
        addImageClasses,
        addBlockquoteClass,
        addNoteBoxes,
        splitEmbeddedQuotes,
        convertTablesToColumns,
        formatSourceText,
        removeInlineStyles
      };

      // Recursive function to process directories
      const processDirectoryRecursive = async (sourceHandle, targetHandle, relativePath = '') => {
        for await (const [name, handle] of sourceHandle.entries()) {
          const currentPath = relativePath ? `${relativePath}/${name}` : name;
          
          if (handle.kind === 'directory') {
            try {
              const targetSubDir = await targetHandle.getDirectoryHandle(name, { create: true });
              await processDirectoryRecursive(handle, targetSubDir, currentPath);
            } catch (error) {
              console.error(`Error creating directory ${currentPath}:`, error);
            }
          } else if (handle.kind === 'file') {
            if (name.toLowerCase().endsWith('.html') || name.toLowerCase().endsWith('.htm')) {
              try {
                setResult(`Processing: ${currentPath}...`);
                const file = await handle.getFile();
                const content = await file.text();
                const transformedContent = transformHtml(content, banner, footer, transformOptions);
                const fileName = (prefix && prefix !== 'None') ? `${prefix} ${name}` : name;
                const targetFileHandle = await targetHandle.getFileHandle(fileName, { create: true });
                const writable = await targetFileHandle.createWritable();
                await writable.write(transformedContent);
                await writable.close();
                processedCount++;
                console.log(`Processed: ${currentPath} -> ${fileName}`);
              } catch (fileError) {
                console.error(`Error processing file ${currentPath}:`, fileError);
              }
            } else {
              try {
                setResult(`Copying: ${currentPath}...`);
                const file = await handle.getFile();
                const targetFileHandle = await targetHandle.getFileHandle(name, { create: true });
                const writable = await targetFileHandle.createWritable();
                await writable.write(file);
                await writable.close();
                copiedCount++;
                console.log(`Copied: ${currentPath}`);
              } catch (copyError) {
                console.error(`Error copying file ${currentPath}:`, copyError);
              }
            }
          }
        }
      };

      // Start recursive processing
      await processDirectoryRecursive(sourceDir, targetDir);

      // Calculate time saved and processing time
      const processingTime = Math.round((Date.now() - startTime) / 1000);
      const timeSaved = calculateTimeSaved(processedCount);
      
      // Try to log to database (optional - won't break if database fails)
      try {
        const conversionData = {
          sourceDirectory: sourceDir.name,
          targetDirectory: targetDir.name,
          banner,
          footer,
          prefix,
          hideFirstH2,
          addImageClasses,
          addBlockquoteClass,
          addNoteBoxes,
          splitEmbeddedQuotes,
          convertTablesToColumns,
          formatSourceText,
          removeInlineStyles,
          htmlFilesProcessed: processedCount,
          otherFilesCopied: copiedCount,
          totalFiles: processedCount + copiedCount,
          processingTimeSeconds: processingTime,
          timeSavedMinutes: processedCount * 15,
          status: 'completed'
        };

        await logConversionToDatabase(conversionData);
      } catch (dbError) {
        console.log('Database logging failed (non-critical):', dbError);
      }

      setResult(`Directory processing complete! 
        ${processedCount} HTML files processed and transformed.
        ${copiedCount} other files copied.
        Total files handled: ${processedCount + copiedCount}
        Processing time: ${processingTime} seconds
        Time saved: ${timeSaved} (@ 15 min per file)`);
        
    } catch (error) {
      console.error('Processing error:', error);
      setResult('Error during processing: ' + error.message);
    } finally {
      setProcessing(false);
    }
  };

  if (!isFileSystemSupported) {
    const isSecureContext = window.isSecureContext;
    const protocol = window.location.protocol;
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    
    return (
      <div className="App">
        <div className="error-message">
          <h1>File System Access API Not Available</h1>
          <p>This application requires Chrome 86+ with File System Access API support.</p>
          
          <div style={{ textAlign: 'left', marginTop: '20px' }}>
            <h3>Debug Information:</h3>
            <p><strong>Secure Context (HTTPS):</strong> {isSecureContext ? '✅ Yes' : '❌ No'}</p>
            <p><strong>Protocol:</strong> {protocol}</p>
            <p><strong>Is Localhost:</strong> {isLocalhost ? '✅ Yes' : '❌ No'}</p>
            <p><strong>showDirectoryPicker:</strong> {'showDirectoryPicker' in window ? '✅ Available' : '❌ Not Available'}</p>
          </div>
          
          <div style={{ textAlign: 'left', marginTop: '20px' }}>
            <h3>Possible Solutions:</h3>
            <ul>
              <li><strong>If running locally:</strong> Make sure you're using <code>http://localhost:3000</code> (not 127.0.0.1)</li>
              <li><strong>If deploying:</strong> Must use HTTPS</li>
              <li><strong>Chrome flags:</strong> Try enabling in <code>chrome://flags/#file-system-access-api</code></li>
              <li><strong>Chrome version:</strong> Update to Chrome 86+ (latest recommended)</li>
              <li><strong>Try:</strong> Incognito mode or different Chrome profile</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <div className="title">
        <h1>Course CSS Swap</h1>
      </div>

      <div className="box">
        <button onClick={selectSourceDirectory} className="button-style">
          Select Source Directory
        </button>
        <span className="sourceText">
          {sourceDir ? sourceDir.name : 'No directory selected'}
        </span>
      </div>

      <div className="input-group">
        <label htmlFor="bannerSelect">Banner Type:</label>
        <select 
          id="bannerSelect" 
          className="button-style"
          value={banner} 
          onChange={(e) => setBanner(e.target.value)}
        >
          <option value="none">None</option>
          <option value="banner">Banner</option>
          <option value="bannerTimeline">Banner Timeline</option>
          <option value="bannerPagination">Banner Pagination</option>
          <option value="progressive">Progressive Banner</option>
          <option value="timeline">Timeline</option>
          <option value="pagination">Pagination</option>
        </select>
      </div>

      <div className="input-group">
        <label htmlFor="footerSelect">Footer Type:</label>
        <select 
          id="footerSelect" 
          className="button-style"
          value={footer} 
          onChange={(e) => setFooter(e.target.value)}
        >
          <option value="None">None</option>
          <option value="ClassicDiamond">Classic Diamond</option>
          <option value="Image">Image</option>
        </select>
      </div>

      <div className="input-group">
        <label htmlFor="prefixSelect">File Prefix:</label>
        <select 
          id="prefixSelect" 
          className="button-style"
          value={prefix} 
          onChange={(e) => setPrefix(e.target.value)}
        >
          <option value="None">None</option>
          <option value="Module">Module</option>
          <option value="Week">Week</option>
          <option value="Session">Session</option>
          <option value="Unit">Unit</option>
          <option value="Lesson">Lesson</option>
        </select>
      </div>

      {/* TRANSFORMATION OPTIONS */}
      <div className="features-section">
        <div className="features-header">
          <h3>Transformation Options</h3>
        </div>
        
        <div className="features-grid">
          <label className="feature-item">
            <input 
              type="checkbox" 
              checked={hideFirstH2}
              onChange={(e) => setHideFirstH2(e.target.checked)}
            />
            <div className="feature-content">
              <div className="feature-title">Hide First H2</div>
              <div className="feature-desc">Comment out first H2 and following HR</div>
            </div>
          </label>

          <label className="feature-item">
            <input 
              type="checkbox" 
              checked={addImageClasses}
              onChange={(e) => setAddImageClasses(e.target.checked)}
            />
            <div className="feature-content">
              <div className="feature-title">Add Image Classes</div>
              <div className="feature-desc">Apply img-20-big and center classes</div>
            </div>
          </label>

          <label className="feature-item">
            <input 
              type="checkbox" 
              checked={addBlockquoteClass}
              onChange={(e) => setAddBlockquoteClass(e.target.checked)}
            />
            <div className="feature-content">
              <div className="feature-title">Convert to Blockquotes</div>
              <div className="feature-desc">Change &lt;p&gt;&lt;em&gt; to &lt;blockquote&gt;</div>
            </div>
          </label>

          <label className="feature-item">
            <input 
              type="checkbox" 
              checked={addNoteBoxes}
              onChange={(e) => setAddNoteBoxes(e.target.checked)}
            />
            <div className="feature-content">
              <div className="feature-title">Wrap NOTE Paragraphs</div>
              <div className="feature-desc">Add note-box div around NOTE: text</div>
            </div>
          </label>

          <label className="feature-item">
            <input 
              type="checkbox" 
              checked={splitEmbeddedQuotes}
              onChange={(e) => setSplitEmbeddedQuotes(e.target.checked)}
            />
            <div className="feature-content">
              <div className="feature-title">Split Embedded Quotes</div>
              <div className="feature-desc">Extract quotes from paragraphs</div>
            </div>
          </label>

          <label className="feature-item">
            <input 
              type="checkbox" 
              checked={convertTablesToColumns}
              onChange={(e) => setConvertTablesToColumns(e.target.checked)}
            />
            <div className="feature-content">
              <div className="feature-title">Tables to Columns</div>
              <div className="feature-desc">Convert 2-cell tables with images to divs</div>
            </div>
          </label>

          <label className="feature-item">
            <input 
              type="checkbox" 
              checked={formatSourceText}
              onChange={(e) => setFormatSourceText(e.target.checked)}
            />
            <div className="feature-content">
              <div className="feature-title">Format Source Text</div>
              <div className="feature-desc">Convert to sourcetitle/source classes</div>
            </div>
          </label>

          <label className="feature-item">
            <input 
              type="checkbox" 
              checked={removeInlineStyles}
              onChange={(e) => setRemoveInlineStyles(e.target.checked)}
            />
            <div className="feature-content">
              <div className="feature-title">Remove Inline Styles</div>
              <div className="feature-desc">Strip all style="..." attributes</div>
            </div>
          </label>
        </div>
      </div>

      <div className="box">
        <button onClick={selectTargetDirectory} className="button-style">
          Select Target Directory
        </button>
        <span className="sourceText">
          {targetDir ? targetDir.name : 'No directory selected'}
        </span>
      </div>

      <div className="box">
        <button 
          onClick={processDirectory} 
          className={`process ${processing ? 'processing' : ''}`}
          disabled={!sourceDir || !targetDir || processing}
        >
          {processing ? 'Processing...' : 'Process Directory'}
        </button>
      </div>

      {result && (
        <div className="result-message">
          <p>{result}</p>
        </div>
      )}

      {/* Bottom Stats Display */}
      {stats && (
        <div style={{ 
          background: 'var(--clr-white)', 
          border: '1px solid var(--clr-border)',
          borderRadius: '8px', 
          padding: '15px',
          margin: '20px 0',
          textAlign: 'center'
        }}>
          <h4 style={{ 
            margin: '0 0 15px 0', 
            color: 'var(--clr-primary)',
            fontSize: '16px'
          }}>
            Total Database Statistics
          </h4>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))', 
            gap: '15px',
            fontSize: '14px'
          }}>
            <div>
              <div style={{ fontSize: '20px', fontWeight: 'bold', color: 'var(--clr-accent)' }}>
                {stats.total_sessions || 0}
              </div>
              <small>Sessions</small>
            </div>
            <div>
              <div style={{ fontSize: '20px', fontWeight: 'bold', color: 'var(--clr-accent)' }}>
                {stats.total_html_files_processed || 0}
              </div>
              <small>Files Processed</small>
            </div>
            <div>
              <div style={{ fontSize: '20px', fontWeight: 'bold', color: 'var(--clr-accent)' }}>
                {formatTimeSaved((stats.total_html_files_processed || 0) * 15)}
              </div>
              <small>Time Saved</small>
            </div>
            <div>
              <div style={{ fontSize: '20px', fontWeight: 'bold', color: 'var(--clr-accent)' }}>
                {stats.sessions_last_24h || 0}
              </div>
              <small>Today</small>
            </div>
          </div>
        </div>
      )}

      <div>
        <p className="version">Version: 1.1</p>
      </div>
    </div>
  );
}

export default App;